var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    width: "100px",
    height: "100px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a5.35 5.35 0 0 0-5.5 5.18c0 3.23 2.59 3.23 2.59 5.17v3.06A2.77 2.77 0 0 0 8 16a2.78 2.78 0 0 0 2.92-2.59v-3.06c0-1.94 2.59-1.94 2.59-5.17A5.35 5.35 0 0 0 8 0zm0 14.75a1.54 1.54 0 0 1-1.65-1.34V12.2h3.31v1.21A1.55 1.55 0 0 1 8 14.75zm3.1-7.16a3.75 3.75 0 0 0-1.43 2.76V11H6.34v-.6a3.75 3.75 0 0 0-1.43-2.81 2.87 2.87 0 0 1-1.16-2.41A4.1 4.1 0 0 1 8 1.25a4.1 4.1 0 0 1 4.25 3.93 2.87 2.87 0 0 1-1.16 2.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2.66a3 3 0 0 0-2.13.85 2.33 2.33 0 0 0-.73 1.69.62.62 0 0 0 .62.63.63.63 0 0 0 .63-.63 1.1 1.1 0 0 1 .36-.8A1.74 1.74 0 0 1 8 3.91a.63.63 0 1 0 0-1.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.fcdd8956d7974f4ba2c55f037e356d86.svg";
export { ForwardRef as ReactComponent };